import { CoreDialogActions, CoreDialogContent } from '@youscience/core';

import {
  sxStyles,
  StyledCancelBtn,
  StyledDialog,
  StyledDialogTitle,
  StyledContinueBtn,
} from './LeavingSiteModal.styles';

export interface LeavingSiteModalProps {
  isOpenLeavingSiteModal: boolean;
  website: string;
  onContinue: () => void;
  onCancel: () => void;
}

export const LeavingSiteModal = (props: LeavingSiteModalProps) => {
  const { isOpenLeavingSiteModal, website, onCancel, onContinue } = props;

  return (
    <StyledDialog
      data-testid="leavingSiteDialog"
      open={isOpenLeavingSiteModal}
      ariaLabelledby="leavingSiteDialogTitle"
      onClose={onCancel}
    >
      <StyledDialogTitle id="leavingSiteDialogTitle">See you again soon!</StyledDialogTitle>

      <CoreDialogContent>You are now being redirected to {website} </CoreDialogContent>

      <CoreDialogActions data-testid="dialogFooter" sx={sxStyles.footer}>
        <StyledCancelBtn type="button" onClick={onCancel}>
          Cancel
        </StyledCancelBtn>

        <StyledContinueBtn onClick={onContinue}>Continue</StyledContinueBtn>
      </CoreDialogActions>
    </StyledDialog>
  );
};
